import React, { useMemo } from 'react';
import { useLocalizationContext, useTranslate, Translate } from '@im/react-localization';
import { DropdownMenu } from '../DropdownMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export function CulturePickerZenith(props) {
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid;
  var context = useLocalizationContext();
  var supportedLocales = context.supportedLocales;
  var translate = useTranslate();
  var options = useMemo(function () {
    return supportedLocales ? supportedLocales.map(function (locale) {
      return {
        content: /*#__PURE__*/_jsx(Translate, {
          text: "Culture.".concat(locale)
        }),
        id: locale,
        onClick: function onClick(e) {
          context.setLocale(locale);
        },
        selected: context.locale === locale,
        value: locale
      };
    }) : [];
  }, [context, supportedLocales]);
  if (!supportedLocales || supportedLocales.length < 2) {
    return null;
  }
  return /*#__PURE__*/_jsx(DropdownMenu, {
    menuItemProps: options,
    menuTriggerProps: {
      buttonText: translate("Culture.".concat(context.locale)),
      'data-testid': "".concat(testid, "-CulturePicker-SelectOption"),
      fitMenuWidthToTriggerWidth: true,
      triggerType: 'Button',
      variant: 'secondary-gray'
    },
    "data-element": "DropdownMenu",
    "data-component": "CulturePickerZenith",
    "data-source-file": "CulturePickerZenith.tsx"
  });
}